import { individualProducts } from 'locales/ja/individual_products';
import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/individual_products`;

type IndividualProductsRecordType = Required<{
  id: number;
  license_id: number;
  title: string;
  available_days: number;
  day_of_week: number | null;
}>;

const product1 = 'DXリテラシー人材育成プログラム';

const individualProductsRecords: IndividualProductsRecordType[] = [
  {
    id: 1,
    license_id: 1,
    title: product1,
    available_days: 90,
    day_of_week: 0,
  },
  {
    id: 2,
    license_id: 2,
    title: 'AI・データ活用人材育成プログラム',
    available_days: 180,
    day_of_week: 1,
  },
  {
    id: 3,
    license_id: 3,
    title: 'AI・データ活用人材育成プログラム（Python）',
    available_days: 180,
    day_of_week: 2,
  },
  {
    id: 4,
    license_id: 4,
    title: 'ビジネスアーキテクト育成プログラム',
    available_days: 180,
    day_of_week: 3,
  },
  {
    id: 5,
    license_id: 5,
    title: 'データサイエンティスト育成プログラム',
    available_days: 180,
    day_of_week: null,
  },
];

type IndividualProductsPurchasedRecordType = Required<{
  uuid: string;
  product_id: number;
  title: string;
  starts_at: string;
  ends_at: string;
  price: number;
  purchased_at: string;
}>;

const individualProductsPurchasedRecords: IndividualProductsPurchasedRecordType[] =
  [
    {
      uuid: '1',
      product_id: 1,
      title: product1,
      starts_at: '2025-09-01T10:00:00+09:00',
      ends_at: '2025-11-29T10:00:00+09:00',
      price: 3300,
      purchased_at: '2025-08-11T10:00:00+09:00',
    },
    {
      uuid: '2',
      product_id: 2,
      title: 'AI・データ活用人材育成プログラム',
      starts_at: '2025-09-02T10:00:00+09:00',
      ends_at: '2026-02-28T10:00:00+09:00',
      price: 16500,
      purchased_at: '2025-08-14T10:00:00+09:00',
    },
    {
      uuid: '3',
      product_id: 3,
      title: 'AI・データ活用人材育成プログラム（Python）',
      starts_at: '2025-09-03T10:00:00+09:00',
      ends_at: '2026-03-01T10:00:00+09:00',
      price: 16500,
      purchased_at: '2025-08-19T10:00:00+09:00',
    },
    {
      uuid: '4',
      product_id: 4,
      title: 'ビジネスアーキテクト育成プログラム',
      starts_at: '2025-09-04T10:00:00+09:00',
      ends_at: '2026-03-02T10:00:00+09:00',
      price: 16500,
      purchased_at: '2025-08-22T10:00:00+09:00',
    },
    {
      uuid: '5',
      product_id: 5,
      title: 'データサイエンティスト育成プログラム',
      starts_at: '2025-09-05T10:00:00+09:00',
      ends_at: '2026-03-03T10:00:00+09:00',
      price: 16500,
      purchased_at: '2025-08-26T10:00:00+09:00',
    },
  ];

export const individualProductsHandlers = [
  // 個人向け商品一覧取得
  http.get(baseUrl, async ({ request }) => {
    const filteredRecords: IndividualProductsRecordType[] =
      individualProductsRecords;
    const searchRequest = Object.fromEntries(
      new URL(request.url).searchParams.entries()
    ) as Partial<{
      order_by: string;
      desc_order: string;
      page: string;
      per: string;
    }>;

    console.group(baseUrl);
    console.table(searchRequest);

    filteredRecords.sort((a, b) => {
      return searchRequest.order_by && searchRequest.desc_order === 'true'
        ? b.id - a.id
        : a.id - b.id;
    });

    console.info(filteredRecords);

    const per = searchRequest.per ? Number(searchRequest.per) : 20;
    const lastPage = Math.ceil(filteredRecords.length / per);
    const paginatedSearchedRecords = new Array(lastPage)
      .fill(undefined)
      .map((_, i) => filteredRecords.slice(i * per, (i + 1) * per));
    const currentPage =
      (searchRequest.page ? Number(searchRequest.page) : 1) > lastPage
        ? lastPage
        : searchRequest.page
        ? Number(searchRequest.page)
        : 1;

    const response = {
      products: paginatedSearchedRecords[currentPage - 1],
      // total_count: filteredRecords.length,
    };

    console.info(response);
    console.groupEnd();

    return HttpResponse.json(response);
  }),
  // 個人向け商品購入申込
  http.post(`${baseUrl}/:id/purchase_request`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      starts_at: string;
      receive_grant: boolean;
      grant_receivable: boolean;
      information_source:
        | 'search_engine'
        | 'sns'
        | 'mail_mag'
        | 'company'
        | 'friend'
        | 'seminar'
        | 'experience'
        | 'other';
      motive: 'skill' | 'company' | 'career' | 'self_improvement' | 'other';
      receipt_name: string;
      accept_privacy_policy: boolean;
      accept_toc: boolean;
      accept_curriculum: boolean;
    };
    console.info(postRequest);

    return HttpResponse.json({
      stripe_checkout_session_url: 'https://stripe-checkout-sessio-url',
    });
  }),
  // 個人向け商品購入申込履歴取得
  http.get(`${baseUrl}/purchase_requests/:uuid`, async () => {
    const response = {
      individualProductId: individualProductsRecords[1].id,
      startsAt: '2025-07-30T00:00:00+09:00',
      receiveGrant: true,
      grantReceivable: true,
      informationSource: 'search_engine',
      motive: 'skill',
    };

    console.info(response);

    return HttpResponse.json(response);
  }),
  // 個人向け商品購入
  http.post(`${baseUrl}/purchase`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      stripe_session_id: string;
    };
    console.info(postRequest);

    const responseBase = {
      stripe_session_status: 'complete',
      stripe_payment_status: 'paid',
      product_id: 1,
      product_title: product1,
      purchased_individual_productId: 1,
      starts_at: '2025-09-07T10:00:00+09:00',
      ends_at: '2025-12-05T10:00:00+09:00',
      receiptUrl: 'http://example.com/receipt',
    };

    let response = responseBase;

    if (postRequest.stripe_session_id === 'invalid') {
      return HttpResponse.json(
        {
          error_type: 'error',
          message: 'uuidが不正です',
        },
        { status: 400 }
      );
    } else if (postRequest.stripe_session_id === 'notFound') {
      return HttpResponse.json(
        {
          error_type: 'error',
          message: `${individualProducts.resourceName}が見つかりません`,
        },
        { status: 404 }
      );
    } else if (postRequest.stripe_session_id === 'error') {
      response = {
        ...responseBase,
        stripe_session_status: 'complete',
        stripe_payment_status: 'unpaid',
      };
    } else if (postRequest.stripe_session_id === 'inProgress') {
      response = {
        ...responseBase,
        stripe_session_status: 'open',
        stripe_payment_status: 'unpaid',
      };
    }

    return HttpResponse.json(response);
  }),
  // 個人向け商品購入履歴一覧取得
  http.get(`${baseUrl}/purchased`, async ({ request }) => {
    const filteredRecords: IndividualProductsPurchasedRecordType[] =
      individualProductsPurchasedRecords;
    const searchRequest = Object.fromEntries(
      new URL(request.url).searchParams.entries()
    ) as Partial<{
      order_by: string;
      desc_order: string;
      page: string;
      per: string;
    }>;

    console.group(baseUrl);
    console.table(searchRequest);

    filteredRecords.sort((a, b) => {
      return searchRequest.order_by && searchRequest.desc_order === 'true'
        ? b.product_id - a.product_id
        : a.product_id - b.product_id;
    });

    console.info(filteredRecords);

    const per = searchRequest.per ? Number(searchRequest.per) : 20;
    const lastPage = Math.ceil(filteredRecords.length / per);
    const paginatedSearchedRecords = new Array(lastPage)
      .fill(undefined)
      .map((_, i) => filteredRecords.slice(i * per, (i + 1) * per));
    const currentPage =
      (searchRequest.page ? Number(searchRequest.page) : 1) > lastPage
        ? lastPage
        : searchRequest.page
        ? Number(searchRequest.page)
        : 1;

    const response = {
      purchased_products: paginatedSearchedRecords[currentPage - 1],
      total_count: filteredRecords.length,
    };

    console.info(response);
    console.groupEnd();

    return HttpResponse.json(response);
  }),
  // 個人向け商品購入履歴取得
  http.get(`${baseUrl}/purchased/:uuid`, async ({ params }) => {
    const { uuid } = params;
    const foundRecord = individualProductsPurchasedRecords.find(
      (record) => record.uuid === uuid
    );

    if (foundRecord) {
      return HttpResponse.json({
        ...foundRecord,
        receiptUrl: 'http://example.com/receipt',
      });
    } else {
      return HttpResponse.json(
        { error_type: 'error', message: '商品が見つかりません' },
        { status: 404 }
      );
    }
  }),
];
